var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2929 21.9168C17.6834 22.3073 18.3166 22.3073 18.7071 21.9168L25.0711 15.5528C25.4616 15.1623 25.4616 14.5291 25.0711 14.1386C24.6805 13.7481 24.0474 13.7481 23.6569 14.1386L18 19.7955L12.3431 14.1386C11.9526 13.7481 11.3195 13.7481 10.9289 14.1386C10.5384 14.5291 10.5384 15.1623 10.9289 15.5528L17.2929 21.9168ZM17 0V21.2097H19V0L17 0Z",
    fill: "#160625"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.46V20.92C1 24.2337 3.68629 26.92 7 26.92H29C32.3137 26.92 35 24.2337 35 20.92V13.46",
    stroke: "#160625",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.0c64ab410aa8610f0ba3ef810a9d92ad.svg";
export { ForwardRef as ReactComponent };